import { SCREEN_HEIGHT, SCREEN_WIDTH, getScreenSize } from '../../../tornado/utils/sizes';
import { getLBannerWidthScale, getLBannerHeightScale } from '../../../video/lBanner/lBanner.utils';

export const createRenderers = () => {
  // OIPF renderer
  const container = document.createElement('div');
  container.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; overflow: hidden;';

  const video = document.createElement('object');
  video.setAttribute('id', 'video');
  video.setAttribute('type', 'application/dash+xml');
  video.style.cssText = 'position: absolute; top: 0; right: 0;';

  container.className = 'video-container';

  container.appendChild(video);
  document.body.appendChild(container);

  return { container, video };
};

export const createAdRenderers = () => {
  // video element renderer
  const container = document.createElement('div');
  container.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; overflow: hidden;';

  const video = document.createElement('video');
  video.setAttribute('crossorigin', 'anonymous');
  video.style.cssText = 'width: 100%; height: 100%; position: absolute; top: 0; right: 0;';

  container.className = 'video-container';

  container.appendChild(video);
  document.body.appendChild(container);

  return { container, video };
};

export const switchLBannerState = (videoEl, enable) => {
  if (!videoEl) return;
  const fullWidth = SCREEN_WIDTH[getScreenSize()];
  const fullHeight = SCREEN_HEIGHT[getScreenSize()];
  if (enable) {
    const width = Math.floor(fullWidth * (1 - getLBannerWidthScale()));
    const height = Math.floor(fullHeight * (1 - getLBannerHeightScale()));
    videoEl.removeAttribute('_opera_dae_full_screen');
    videoEl.setFullScreen(false);
    videoEl.style.width = `${width}px`;
    videoEl.style.height = `${height}px`;
  } else {
    videoEl.setFullScreen(true);
    videoEl.style.width = `${fullWidth}px`;
    videoEl.style.height = `${fullHeight}px`;
  }
};
